module.exports = __webpack_public_path__ + "img/pentest-fill.0456c3b4.png";